<template>
	<div class="table-widget-field">
		<default-widget-field v-bind="defaultFieldProps" v-on="defaultFieldListeners" />
		<v-input :ref="fieldRef" data-lpignore="true" v-model="value" v-bind="activeFormFieldCommonProps">
			<div class="width-100">
				<TableDisplay
					:pageSize="pageSize"
					:columnOrder="columnOrder"
					:headers="headers"
					:selectedRows.sync="tableValue"
					:fieldsEditable="isEditable"
					:addRowEnabled="addRowEnabled"
					:rows="formattedPreviousSteps"
					:isSelectionOn="userSelectionEnabled"
					:isMultipleSelection="isMultipleSelection"
					:isSearchOn="isSearch"
					@field-event="(v) => $emit('field-event', v)"
				/>
			</div>
		</v-input>
	</div>
</template>

<script>
import TableDisplay from './TableDisplay';
import DefaultWidgetField from '../DefaultWidgetField';
import MultiItemSourceFieldMixin from '../MultiItemSourceField/MultiItemSourceFieldMixin';
import WidgetFieldMixin from '../WidgetFieldMixin';
import { flattenPreserveArrays, formatArray } from '@/utils/helpers';

function stringifyArrays(table) {
	return table.map((row) => Object.fromEntries(Object.entries(row).map(([k, v]) => [k, Array.isArray(v) ? formatArray(v) : v])));
}

export default {
	name: 'TableField',
	components: {
		TableDisplay,
		DefaultWidgetField,
	},
	mixins: [WidgetFieldMixin, MultiItemSourceFieldMixin],
	computed: {
		headers() {
			return this.field.metadata.options.headers || [];
		},
		formattedPreviousSteps() {
			return stringifyArrays(this.preStep.map((row) => flattenPreserveArrays(row)));
		},
		isEditable() {
			return !!this.fieldOptions.editable?.enabled;
		},
		addRowEnabled() {
			return this.isEditable && !!this.fieldOptions.add_rows?.enabled; // Require it to be editable and enabled.
		},
		pageSize() {
			return this.fieldOptions.page_size.value;
		},
		columnOrder() {
			return this.fieldOptions.column_order.value;
		},
		tableValue: {
			get() {
				// prevent exceptions on edit
				return this.value || [];
			},
			set(v) {
				this.value = v;
			},
		},
	},
};
</script>
<style scoped lang="scss">
.table-widget-field {
	$border-color: var(--forth-border-color);
	text-align: left;
}
::v-deep {
	.v-input__icon {
		height: 11px;
	}
}
</style>
